import { render } from "./NBURatesCreep3d.vue?vue&type=template&id=0a55fd1c&scoped=true"
import script from "./NBURatesCreep3d.vue?vue&type=script&lang=js"
export * from "./NBURatesCreep3d.vue?vue&type=script&lang=js"

import "./NBURatesCreep3d.vue?vue&type=style&index=0&id=0a55fd1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a55fd1c"]])

export default __exports__